import { TdsButton, TdsTypography } from "@tds/react";
import { Trans } from "react-i18next";
import logo from "../../images/ThalesLogo.png";
import "./styled.css";

export default function LastPage() {
  return (
    <div className="final-wrapper">
      <div className="final-header">
        <img className="final-logo" src={logo} />
      </div>
      <div className="final-content">
        <TdsTypography fontSize="5" classes="question mb-xs font-bold">
          <p>
            <Trans i18nKey="thankyou"></Trans>
          </p>
        </TdsTypography>
        <TdsTypography
          fontSize="7"
          classes="question-section text text-bluegrey-900"
        >
          <Trans i18nKey="q9"></Trans>
        </TdsTypography>
        <TdsTypography
          fontSize="7"
          classes="question-section text text-bluegrey-400 mt-xs "
        >
          <Trans i18nKey="q10"></Trans>
        </TdsTypography>
        <TdsTypography
          fontSize="7"
          classes="question-section text text-bluegrey-400"
        >
          <Trans i18nKey="q11"></Trans>
        </TdsTypography>

        <TdsButton
          id="btnSubmit"
          variant="outline"
          color="primary"
          classes="mt-s"
          onClick={() => window.location.reload()}
        >
          <Trans i18nKey="submitAnother"></Trans>
        </TdsButton>
      </div>
    </div>
  );
}
